import request from "@/utils/request";
export const getCooperationInfo = () => {
    return request.get("/cooperation/info");
};
export const updateCooperationInfo = (data) => {
    return request.put("/cooperation/info", data);
};
